export default __webpack_public_path__ + "static/media/room-propolis-2.043346e5.webp";